import { UniformText } from "./text";
export type { TextProps } from "./text";

export default UniformText;
